/**
 * Checkbox field
 */
import React from "react"
import PropTypes from "prop-types"
import { ErrorMessage, Row, Label, Wrapper } from "./styles"
import Text from "../Text"
import Icon from "../Icon"
import Translate from "components/Translate/container"

class CheckboxField extends React.Component {
  handleChange = value => {
    const { id, onChange, callback } = this.props
    if (onChange) {
      onChange(id, value, callback)
    }
  }

  handleKeyPress = (value, event) => {
    const { id, onChange, callback } = this.props
    if (onChange && (event.key = "Enter")) {
      onChange(id, value, callback)
    }
  }

  render() {
    const {
      checked,
      labelComponent,
      label,
      labelMargin,
      labelColour,
      forceErrorDisplay,
      error,
      id,
      errorMessage,
      disabled,
      whiteBG,
      translate = true,
    } = this.props

    return (
      <div>
        <Row disabled={disabled}>
          <div
            role="checkbox"
            aria-label={`Checkbox: ${label}`}
            aria-checked={checked ? checked : false}
            tabIndex="0"
            onClick={() => {
              this.handleChange(!checked)
            }}
            onKeyPress={event => {
              this.handleKeyPress(!checked, event)
            }}
          >
            <Wrapper
              id={id}
              tabindex={"0"}
              value={checked}
              whiteBG={whiteBG}
              hasError={error && forceErrorDisplay}
            >
              <Icon
                variant={
                  checked
                    ? error && forceErrorDisplay
                      ? "checkbox_selected_error"
                      : "checkbox_selected"
                    : error && forceErrorDisplay
                    ? "checkbox_error"
                    : "checkbox"
                }
              />
            </Wrapper>
          </div>
          <Label
            className={error && forceErrorDisplay ? "hasError" : ""}
            labelMargin={labelMargin}
            hasError={error && forceErrorDisplay}
            labelColour={labelColour}
          >
            {label && (translate ? <Translate>{label}</Translate> : label)}
            {labelComponent &&
              (translate ? (
                <Translate>{labelComponent}</Translate>
              ) : (
                labelComponent
              ))}
          </Label>
        </Row>

        {forceErrorDisplay && error && errorMessage ? (
          <ErrorMessage>
            <Text variant={"errorInputHelp"} id={`error-${id}`}>
              <Translate>
                {translate ? (
                  <Translate>{errorMessage}</Translate>
                ) : (
                  errorMessage
                )}
              </Translate>
            </Text>
          </ErrorMessage>
        ) : null}
      </div>
    )
  }
}

CheckboxField.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.node,
  labelComponent: PropTypes.node,
  label: PropTypes.string,
  labelColour: PropTypes.string,
  hint: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  whiteBG: PropTypes.string,
}

export default CheckboxField
